module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-Regular.ebe27ba5.woff2";